// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"emptyMessage_emptyMessage__1Z5wx"};